import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {ArticleEbookCard} from "./ArticleEbookCard";

const ebook20questions465x719 = require("../assets/ebook_20_questions_465x719.png");
const ebookPayingDebt465x719 = require("../assets/ebook_paying_debt_465x719.png");
const ebookABC465x719 = require("../assets/ebook_abc_465x719.png");
const ebookGuide465x719 = require("../assets/ebook_przewodnik_jak_kupic_mieszkanie_na_rynku_pierwotnym_465x719.png");

const ebook20MistakesPDF = "/static-rp/pdf/rebranding/ebook_20_bledow_przy_zakupie_mieszkania_v2.pdf";
const ebook20WaysToImproveCreditPDF = "/static-rp/pdf/rebranding/20_sposobow_na_poprawe_zdolnosci_kredytowych_v2.pdf";
const ebookABCPDF = "/static-rp/pdf/rebranding/ABC_ebook_RP_new_2.pdf";
const ebookGuidePDF = "/static-rp/pdf/rebranding/ebook_przewodnik_jak_kupic_mieszkanie_na_rynku_pierwotnym.pdf";

interface IEbookSectionProps {
    className?: string;
}

const ebooks = [
    {source: ebookGuide465x719, title: "Jak kupić mieszkanie na Rynku Pierwotnym", downloadUrl: ebookGuidePDF},
    {source: ebook20questions465x719, title: "20 błędów przy zakupie mieszkania - darmowy ebook", downloadUrl: ebook20MistakesPDF},
    {source: ebookPayingDebt465x719, title: "20 sposobów na poprawę zdolności kredytowej - darmowy ebook", downloadUrl: ebook20WaysToImproveCreditPDF},
    {source: ebookABC465x719, title: "ABC kupna mieszkania - darmowy ebook", downloadUrl: ebookABCPDF}
];

export const ArticleEbookSection = (props: IEbookSectionProps) => {
    const {className} = props;

    return (
        <section className={cx(className, sectionStyle)}>
            <div className={articleContainer}>
                <Text variant="headline_4" as="div">
                    Pobierz darmowe e-booki
                </Text>
                <Text className={css({mb: 4})} variant="body_copy_0" as="div">
                    Poszerz swoją wiedzę o zakupie mieszkania
                </Text>

                <div className={ebookListing}>
                    {ebooks.map((item, index) => (
                        <ArticleEbookCard key={index} source={item.source} title={item.title} downloadURL={item.downloadUrl} />
                    ))}
                </div>
            </div>
        </section>
    );
};

const articleContainer = css({
    md: {
        maxWidth: `calc(103.2rem + 8rem);`, // moved from ArticleContainer - 103.2rem is container width and 8rem is for padding
        ml: "auto",
        mr: "auto",
        pl: "4rem",
        pr: "4rem"
    },
    pl: 2,
    pr: 2
});

const sectionStyle = css({
    backgroundColor: "var(--colors-background-200)",
    pt: 3,
    pb: 5,
    md: {
        pt: 5,
        pb: 9
    }
});

const ebookListing = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3,

    md: {
        justifyContent: "space-between",
        flexDirection: "row",
        columnGap: 3
    }
});
